//import React from 'react';
import {React, useEffect, useState, useRef, useLayoutEffect} from 'react';
import './index2.css';
import '../App.css';
import IntroVideo from '../images/intro_video.mp4';
import Tengu from '../images/Tengu_Mask_Tech Logo_Design2.png';
import Crow_Logo from '../images/crow_electric3.png';
import VideoComponent from './VideoComponent.js';
import SlideInDiv2 from './slider1.js'
import SlideInDivLeft2 from './slider2.js'
//import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import BGwordanimation4 from './BGwordanimation4.js';
import { TbArrowBigRightLines } from "react-icons/tb";
import { AiOutlineLaptop } from "react-icons/ai";
import { TbSettingsSearch } from "react-icons/tb";
import { DiAppstore } from "react-icons/di";
import { AiOutlineConsoleSql } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { useScrollBehavior } from './useScrollBehavior.js'; 
import Footer from './footer.js'

const Home2 = () => {

	useScrollBehavior();

    const centerRef = useRef(null);
    const centerRef2 = useRef(null);
    const [isVisibleCenter, setIsVisibleCenter] = useState(false);
    const [isVisibleCenter2, setIsVisibleCenter2] = useState(false);
	const [isVisibleText, setIsVisibleText] = useState(false);
	const textRef = useRef(null);
	const stickyRef2 = useRef(null);
	const overlayRef2 = useRef(null);
	const subtitleRef = useRef(null);
	const isSubtitleInView = useInView(subtitleRef, { once: true, amount: 0.8 }); 

	const letterAnimation = {
		hidden: { opacity: 0 },
		visible: (i) => ({
		  opacity: 1,
		  transition: {
			delay: i * 0.08,
			duration: 0.5,
		  },
		}),
	  };

	  /*const renderAnimatedLetters = (text, isInViewProp) => {
			  return text.split('').map((char, i) => (
				  <motion.span
					  key={i}
					  custom={i}
					  initial="hidden"
					  animate={isInViewProp ? "visible" : "hidden"}
					  variants={letterAnimation}
					  style={{ display: 'inline-block', whiteSpace: char === ' ' ? 'pre' : 'normal' }}
				  >
					  {char}
				  </motion.span>
			  ));
		  };*/
		  const renderAnimatedLettersByWord = (text, isInView) => {
  const words = text.split(' ');
  let k = 0;
  return words.map((word, wi) => (
    <span className="wordWrap" key={wi}>
      {word.split('').map((char, ci) => (
        <motion.span
          key={`${wi}-${ci}`}
          custom={k++}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={letterAnimation}
          className="char"
        >
          {char}
        </motion.span>
      ))}
      {/* keep a real space so line can break BETWEEN words */}
      {wi < words.length - 1 ? ' ' : null}
    </span>
  ));
};

    const handleScroll2 = () => {
	/*if (linksRef.current) {
	  const linksRect = linksRef.current.getBoundingClientRect();
	  const triggerOffsetLinks = 100;
	  const triggerPointLinks = window.innerHeight - triggerOffsetLinks;
	  const isAboveTriggerPointLinks = linksRect.top < triggerPointLinks;
	  setIsVisibleLinks(isAboveTriggerPointLinks);
	}*/

	if (centerRef.current) {
	  const centerRect = centerRef.current.getBoundingClientRect();
	  const triggerOffsetCenter = 5; // Adjust this value for different trigger points
	  const triggerPointCenter = window.innerHeight - triggerOffsetCenter;
	  const isAboveTriggerPointCenter = centerRect.top < triggerPointCenter;
	  setIsVisibleCenter(isAboveTriggerPointCenter);
	}

    if (centerRef2.current) {
	  const centerRect2 = centerRef2.current.getBoundingClientRect();
	  const triggerOffsetCenter2 = 200; // Adjust this value for different trigger points
	  const triggerPointCenter2 = window.innerHeight - triggerOffsetCenter2;
	  const isAboveTriggerPointCenter2 = centerRect2.top < triggerPointCenter2;
	  setIsVisibleCenter2(isAboveTriggerPointCenter2);
	}

	if (textRef.current) {
		const textRect = textRef.current.getBoundingClientRect();
		const triggerOffsetText = 300; // Adjust this value for different trigger points
		const triggerPointText = window.innerHeight - triggerOffsetText;
		const isAboveTriggerPointText = textRect.top < triggerPointText;
		setIsVisibleText(isAboveTriggerPointText);
	  }

	  /*if (imageRef.current) {
		const imageRect = imageRef.current.getBoundingClientRect();
		const triggerOffsetImage = 130; // Adjust this value for different trigger points
		const triggerPointImage = window.innerHeight - triggerOffsetImage;
		const isAboveTriggerPointImage = imageRect.top < triggerPointImage;
		setIsVisibleImage(isAboveTriggerPointImage);
	  }*/
  };

  useEffect(() => {
	window.addEventListener('scroll', handleScroll2);
	handleScroll2(); // Check visibility on initial render
	return () => {
	  window.removeEventListener('scroll', handleScroll2);
	};
  }, []);
  

  const flipAnimation = {
		hidden: { rotateX: -90, opacity: 0 },
		visible: {
			rotateX: [ -90, 0 ],
			opacity: [0, 1],
			transition: {
				duration: 1,
				ease: "easeInOut",
				delay: .5,  // Adjust this value for the desired delay
			},
		},
	};

	useEffect(() => {
	  const handleScroll4 = () => {
		if (!stickyRef2 || !overlayRef2 || !stickyRef2.current || !overlayRef2.current) return;
		const stickyRect = stickyRef2.current.getBoundingClientRect();
		const overlayRect = overlayRef2.current.getBoundingClientRect();
  
		if (stickyRect.top <= 0 && stickyRect.bottom > overlayRect.height) {
		  overlayRef2.current.style.position = 'fixed';
		  overlayRef2.current.style.top = '0';
		  /*overlayRef.current.style.width = `${stickyRef.current.offsetWidth}px`;*/
		} else if (stickyRect.bottom <= overlayRect.height) {
		  overlayRef2.current.style.position = 'absolute';
		  overlayRef2.current.style.top = `${stickyRect.height - overlayRect.height}px`;
		} else {
		  overlayRef2.current.style.position = 'absolute';
		  overlayRef2.current.style.top = '0';
		}
	  };
  
	  window.addEventListener('scroll', handleScroll4, { passive: true });
	  handleScroll4();
	  return () => {
		window.removeEventListener('scroll', handleScroll4);
	  };
	}, []);

	return (
		<div id='index2_div1'>
            {/* Video Background */}
			<VideoComponent  videoSrc={IntroVideo} />
        	<div className="module" id="moduleOne">
				<div id="new_logo">
  					{/*<img src={Tengu} alt="Tengu" className="tengu1" />*/}
					<img src={Crow_Logo} alt="Tengu" className="tengu1" />
				</div>
				<div id='index2_heading' ref={subtitleRef}>
					{renderAnimatedLettersByWord("Crafting Digital Realities, Tailored to Your Vision.", isSubtitleInView)}
				</div>
            </div>
            <div className="module" id="moduleTwo">
                <div id='mod2_heading' ref={centerRef}>
                    <motion.h1
							id="explore-services-heading2"
                            initial="hidden"
                            animate={isVisibleCenter ? "visible" : "hidden"}
                            variants={flipAnimation}
                        >Websites that Evolve: 
                        </motion.h1>
                   
                    <div  ref={centerRef}>
                        <motion.h1
							id="center_indexdivpara2"
                            initial="hidden"
                            animate={isVisibleCenter ? "visible" : "hidden"}
                            variants={flipAnimation}
                        >Powering Your Business Growth and Performance 
                        </motion.h1>
                        </div>
                </div>
				<div id='mod2_subheading'>
					<Link to="/portfolio" style={{ textDecoration: 'none', color: 'rgb(200, 25, 215)' }}><h1>Noted Projects</h1></Link>
					<Link to="/portfolio" style={{ textDecoration: 'none', color: 'rgb(200, 25, 215)' }}><h2>Explore some of our work</h2></Link>
				</div>
                <div id='index_div5_box_container' ref={centerRef}>
								<div id='index_div5_box1'  className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								  style={{ transitionDelay: '.3s' }}>
									<div  class='service-link' style={{ textDecoration: 'none' }} >
									<div id='index_div5_box1_sub' className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										<Link to="/services1" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>Web Design</Link>
                                        <Link to="/services1" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>Web Development</Link>
									</div>
					
									<div className='index_div5_box_pic' id='index_div5_box_pic1'></div>
										<div className='index_div5_box_pic_text'><h2>Marketing Platform UX for Proxoffensive Security</h2></div>
									</div>
									</div>
								</div>
								<div id='index_div5_box2' className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '.6s' }}>
									<div  class='service-link' style={{ textDecoration: 'none' }}>
									<div id='index_div5_box2_sub' className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										
										<Link to="/seo" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>Search Engine Optimization</Link>
                                        <Link to="/fullstack" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>Full-Stack Digital Solutions</Link>
									</div>
									
									<div className='index_div5_box_pic' id='index_div5_box_pic2'></div>
									 <div className='index_div5_box_pic_text'><h2>Custome Website Design for Tree Service</h2>
										<p>full-Stack Site for secure data</p>
									</div>
									</div>
									</div>
								</div>
								<div id='index_div5_box3' className={`index_div5_box ${isVisibleCenter ? 'visible' : ''}`} 
								style={{ transitionDelay: '.9s' }}>
									<div  class='service-link' style={{ textDecoration: 'none' }} >
									<div id='index_div5_box3_sub' className='index_div5_box_sub_container'>
									<div className='index_div5_box_sub'>
										<Link to="/services1" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>Web Design</Link>
                                        <Link to="/services1" style={{ textDecoration: 'none'}} className='index_div5_box_sub_widget'>UI/UX Design</Link>
									</div>
								
									<div className='index_div5_box_pic' id='index_div5_box_pic3'></div>
										<div className='index_div5_box_pic_text'><h2>Custome Promotional Website</h2></div>
									</div>
									</div>
								</div>
								
							</div>
                	<div id='mod2_arrow'><TbArrowBigRightLines /></div>
            </div>
            <div className="module" id="moduleThree">
                <div id='mod3_div' ref={centerRef2}>
                    <div className='mod3_sub_div'>
                        <div id='mod3_internal_div1' ref={centerRef2} className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '.9s' }}>
									<div id='mod3_internal_div1_sub'>
										<h1>Web Design & Development</h1>
										<br></br>
										<p>Our expertise lies in creating beautiful, SEO-driven 
											web solutions that engage users, accelerate your 
											business's expansion, and profoundly extend your 
											partners' reach and purpose.</p>
									</div>
								</div>
                        <div id='mod3_internal_div2' ref={centerRef2} className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '1.6s' }}>
									<SlideInDiv2>
                                	<div id='white_space2'>
                                		<h1>Captivating Designs That Engage and Convert</h1>
										<br></br>
						        		<p>Let us handle your development needs, so you can focus on what matters most - your business. 
											From design to development 
											and ongoing support. Custom built from scratch or 
											code-takeover project.</p>
                                	</div>
                                </SlideInDiv2>
								</div>
                            
                    </div>
                    <div className='mod3_sub_div'>
                        <div id='mod3_internal_div3' ref={centerRef2} className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '1.2s' }}>
                                <SlideInDivLeft2>
                                	<div id='white_space'>
                                		<h1>Robust Development Solutions for Seamless Performance</h1>
										<br></br>
						        		<p> Web & Graphic Design
    						        		Website Redesigns
    						        		Web Development
    						        		Corporate Identity & Branding
    						        		Search Engine Optimizations</p>
                                	</div>
                                </SlideInDivLeft2>
                                </div>
                        <div id='mod3_internal_div4' ref={centerRef2} className={`mod3_internal_div ${isVisibleCenter2 ? 'visible' : ''}`} 
								style={{ transitionDelay: '1.5s' }}></div>
                    </div>
                </div>

            </div>
            <div className="module" id="moduleFour">
				<BGwordanimation4/>
				<div id='mod4_div1'>
					 <div   className="sticky-element-container2">
      					<div ref={stickyRef2}className="background-div2">
        				<div ref={overlayRef2} className="overlay-container2">
          					<div id='mod4_overlayText2'>
            					<h1>How We Empower Your Business Online</h1>
            					<h3>Tailoring solutions built for performance and growth.</h3>
          					</div>
        
     
        				</div>
          				<div></div>
     				 	</div>
    				</div>
					<div id='mod4_div2'>
						<div id='mod4_sub_div_container'>
							<div className='mod4_sub_div'>
								<Link to="/services1" className="card-link">
								<div id='mod4_Sub_div_icon1'><AiOutlineLaptop /></div>
								<h2>Web Design & Development:</h2>
								<p>Crafting visually stunning, user-friendly, and high-performing 
									websites tailored to your brand</p>
								</Link>
							</div>
							<div className='mod4_sub_div'>
								<Link to="/seo" className="card-link">
								<div id='mod4_Sub_div_icon2'><TbSettingsSearch /></div>
								<h2>Search Engine Optimization (SEO):</h2>
								<p>Boosting your online visibility, driving organic traffic, and 
									helping you dominate search rankings</p>
								</Link>
							</div>
							<div className='mod4_sub_div'>
								<Link to="/app" className="card-link">
								<div id='mod4_Sub_div_icon3'><DiAppstore /></div>
								<h2>App Development (Mobile/Web Apps):</h2>
								<p>Building intuitive, robust, and scalable custom applications 
									that streamline operations and engage your audience.</p>
								</Link>
							</div>
							<div className='mod4_sub_div'>
								<Link to="/fullstack" className="card-link">
								<div id='mod4_Sub_div_icon4'><AiOutlineConsoleSql /></div>
								<h2>Full-Stack Digital Solutions</h2>
								<p>From concept to launch and beyond, we handle every layer of 
									your digital product. Our full-stack expertise ensures seamless 
									integration and optimized performance..</p>
								</Link>
							</div>
						</div>

					</div>
				</div>
            </div>
			<div className="module" id="moduleFive">
				<div id='mod5_div1'>
					<div id='mod5_div1_headidng'>
						<h2>We craft strategic websites that tell your story, convert 
							customers, and scale with you over time.</h2>
					</div>
					<div id='mod5_div1_headidng2' ref={textRef} className={`your-new-text-element ${isVisibleText ? 'fade-in' : ''}`}>
						<h1>Enjoy Our Two Pricing Models</h1>
					</div>
					<div id='mod5_div1_pic_container'>
						<Link to="/about" style={{ textDecoration: 'none'}} id='mod5_div1_pic_container_div1' className='mod5_div1_pic'>
							<div id='mod5_div1_pic_container_div1_pic'>
								<div className='mod5_div1_pic_heading'>
									<h1>Project Based</h1>
								</div>
							</div>
							<div id='mod5_div1_pic_container_div1_sub1'>
								<h3>delivering high-impact project-based solutions tailored to your goals.</h3>
							</div>
						</Link>
						<Link to="/about" style={{ textDecoration: 'none'}} id='mod5_div1_pic_container_div2' className='mod5_div1_pic'>
							<div id='mod5_div1_pic_container_div2_pic'>
								<div className='mod5_div1_pic_heading'>
									<h1>Subscription Based</h1>
								</div>
							</div>
							<div id='mod5_div1_pic_container_div1_sub2'>
								<h3>One flat monthly fee gives you flexible access to our creative, 
									technical, and strategic experts.</h3>
							</div>
						</Link>
					</div>
					
				</div>	
			</div>
			<div className="module" id="moduleSix">
			<div id='index_info_div2'>
			<div id='index_info_div_sub1_2'>
				<div id='index_info_div_sub1_heding2'>Empowering Your Digital Journey</div>
				<div>Collaborate with our expert team to achieve your online goals with innovation and precision.</div>
			</div>
			<div id='index_info_div_sub2_2'>
				<div id='index_info_1_2'>
				<div className='index_info_heading_2'>Responsive Design</div>
				<div className='index_info_subheading_2'>Optimized for All Devices</div>
				<div>In today's mobile-driven landscape, your site needs to shine on every device. 
					Our team will make sure your business captivates customers and delivers a seamless 
					experience, even before they step through your doors.</div>
				</div>	
				<br></br>	
				<div id='index_info_2_2'>
				<div className='index_info_heading_2'>Digital Strategy</div>
				<div className='index_info_subheading_2'>Strategic Insights and Innovative Solutions</div>
				<div>Crafted with precision, our digital strategies offer integrated approaches to 
					enhance your online presence, navigate the digital landscape, and drive measurable 
					results. Let us guide you with cutting-edge tactics to achieve your business goals 
					and stand out in a competitive market.</div>
				</div>			
			</div>
			<div id='index_info_div_sub3_2'>
				<div id='index_info_3_2'>
				<div className='index_info_heading_2'>E-commerce Websites</div>
				<div className='index_info_subheading_2'>Seamless Online Sales</div>
				<div>Ready to boost your sales online? E-commerce solutions are essential 
					for thriving in the digital marketplace, allowing you to reach customers 
					locally, nationally, or globally.</div>
				</div>	
				<br></br>
				<div id='index_info_4_2'>
				<div className='index_info_heading_2'>Brand identity</div>	
				<div className='index_info_subheading_2'>Crafting Unique and Memorable Impressions</div>
				<div>Build a distinctive brand that stands out and resonates. Our approach to 
					brand identity focuses on creating compelling, memorable visuals and messages 
					that capture the essence of your business, engage your audience, and foster a 
					strong connection with your target market. Let us help you define and communicate 
					your brand's unique story.</div>
				</div>	
			</div>


			</div>
		</div>
			<Footer/>
		</div>
	);
};

export default Home2;

/*onClick={() => window.scrollTo(0, 0)}*/